var map = {
	"./gray_large.png": 91937,
	"./gray_medium.png": 70997,
	"./gray_small.png": 4339,
	"./gray_square.png": 70846,
	"./green_large.png": 24986,
	"./green_medium.png": 81366,
	"./green_small.png": 86201,
	"./orange_large.png": 61369,
	"./orange_medium.png": 16741,
	"./orange_small.png": 44202,
	"./yellow_large.png": 24445,
	"./yellow_medium.png": 19212,
	"./yellow_small.png": 21971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34731;